"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Svg = styled_components_1.default.svg `
  enable-background: new 0 0 500 500;
`;
const reduceToPrimary = (children) => {
    if (typeof children === "undefined")
        return children;
    return react_1.default.Children.map(children, (child) => {
        const clonedChild = react_1.default.cloneElement(child, {
            children: (child.props.children && reduceToPrimary(child.props.children)) ||
                undefined,
            fill: (child.props.fill === "currentColor" && "url(#primaryFill)") ||
                undefined,
            stroke: (child.props.stoke === "currentColor" && "url(#primaryFill)") ||
                undefined,
        });
        return clonedChild;
    });
};
const Icon = (props) => {
    const { primary = false, children, size } = props, rest = __rest(props, ["primary", "children", "size"]);
    const updatedChildren = primary
        ? reduceToPrimary(children)
        : children;
    return (react_1.default.createElement(Svg, Object.assign({ "aria-hidden": "true", focusable: "false", role: "img", height: size, width: size, xmlns: "http://www.w3.org/2000/svg" }, rest),
        primary && (react_1.default.createElement("defs", null,
            react_1.default.createElement("pattern", { id: "primaryFill", patternUnits: "userSpaceOnUse", width: "100%", height: "100%" },
                react_1.default.createElement("image", { href: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/fill.png", x: "0", y: "0", width: "100%", height: "100%" })))),
        updatedChildren));
};
exports.default = Icon;
//# sourceMappingURL=iconsCommon.js.map